import { ServiceLayout } from "@/components/service/ServiceLayout";
import { ServiceFAQ } from "@/components/service/ServiceFAQ";
import { HeroSection } from "@/components/workflow-automation/HeroSection";
import { ToolsSection } from "@/components/workflow-automation/ToolsSection";
import { ProcessSection } from "@/components/workflow-automation/ProcessSection";
import { BenefitsSection } from "@/components/workflow-automation/BenefitsSection";
import { ServiceCTA } from "@/components/ui/ServiceCTA";
import { serviceFAQs } from "@/data/service-faqs";

const WorkflowAutomation = () => {
  return (
    <ServiceLayout serviceName="Workflow Automation">
      <HeroSection />
      <ToolsSection />
      <ProcessSection />
      <BenefitsSection />
      <ServiceFAQ faqs={serviceFAQs["workflow-automation"]} serviceName="Workflow Automation" />
      <ServiceCTA serviceName="Workflow Automation" />
    </ServiceLayout>
  );
};

export default WorkflowAutomation;